{
    "FormEngineShowPageWfl": {
        "title": "Show Page",
        "description": "React to events by showing a configured page element"
    },
    "mask": {
        "FormEngineShowPageWfl": {
            "groupTitle": "Page"
        }
    }
}